<template>
    <div id="naviga">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a class="nav-link" href="#KeywordLookup">Keyword Lookup</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#KeywordProfiler">Keyword Profiler</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#FreqKeywords">Frequent Keywords</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#Ngrams">Ngrams</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#TrendChart">Trends</a>
        </li>
        <li v-if="datum.desc.qa" class="nav-item">
          <a class="nav-link" href="#QuestionAnswering">Question Answering</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#ReviewsPanel">Smart Reading</a>
        </li>
      </ul>
    </div>
  </div>
</nav>

    </div>
</template>
<script>
export default{
props:{
    datum:{
        type: Object
    }
}

}
</script>